import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const EventHeaderGroup = withConfig(theme => styled('header', { label: 'EventHeaderGroup' })`
    align-items: center;
    background-color: ${theme.star.collapse.competitionAndMarket.bgColor};
    color: ${theme.star.collapse.competitionAndMarket.txtColor};
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    height: 32px;
    justify-content: start;
    overflow: hidden;
    position: relative;
`);

export const CompetitionName = withConfig(theme => styled('h4', { label: 'CompetitionName' })`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3334;
    margin: 0;
    overflow: hidden;
    padding: 8px;
    text-overflow: ellipsis;
    text-transform: capitalize;
    user-select: none;
    white-space: nowrap;
`);

interface EventHeaderGroupSelectionPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventHeaderGroupSelection = withConfig(theme => styled('div', { label: 'EventHeaderGroupSelection' })<EventHeaderGroupSelectionPropsType>`
    align-items: center;
    display: flex;
    flex: 0 0 150px;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    justify-content: center;
    line-height: 1.2;
    padding: 8px;
    width: 150px;
    @media ${theme.star.mediaQuery.desktop} {
        flex-basis: 148px;
        width: 148px;
    }
    margin-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '4px' : '0'};
    @media ${theme.star.mediaQuery.xxLargeDesktop} {
        flex-basis: 160px;
        width: 160px;
    }
`);
